import ApplicationController from './application_controller'

export default class extends ApplicationController {

	connect() {
		document.body.querySelector('.header-container').scrollIntoView()
		//window.scrollTo(0,0)
	}

}
